import { ExternalLink, Zap, ShoppingBag, Tag } from 'lucide-react';

const LOJAS = [
  {
    nome: 'Mercado Livre',
    desc: 'Nossa loja oficial com avaliações verificadas e entrega rápida',
    url: 'https://www.mercadolivre.com.br/social/costatalita707?matt_word=costatalita707&matt_tool=14032019&forceInApp=true&ref=BNK579plEhnEA2%2F0J3zUVsMmuyt2CRnbPLJkwYsemK82Ox925Lox7vynu2%2BUxMZ2iwUGrTTaHp8oauIwWyOQmDr9y4nitUVe0wjSYcztw2FkeohnkTKWYIcGo5Du77p6RvrMFtVIQtYmW8OLSaYZOKhPNkKOs%2FY2nuzOcefwRuVA9vkclCVMr%2Bl1TBPTyaFH52Q%2BYvesBNknzosQfQpa%2FpNQ7HtEMj63xO4mog%3D%3D',
    emoji: '🛍️',
    label: 'Mercado Livre',
    accent: '#FFE600',
    accentText: '#1a1a1a',
  },
  {
    nome: 'Shopee',
    desc: 'Frete grátis e promoções relâmpago todos os dias',
    url: 'https://s.shopee.com.br/5VSckF353O',
    emoji: '🛒',
    label: 'Shopee',
    accent: '#EE4D2D',
    accentText: '#fff',
  },
  {
    nome: 'Amazon',
    desc: 'Entrega rápida com qualidade garantida Amazon',
    url: 'https://www.amazon.com.br/dp/B0GVPRVCRQ?tag=thealphadroid-20&th=1',
    emoji: '📦',
    label: 'Amazon',
    accent: '#FF9900',
    accentText: '#1a1a1a',
  },
  {
    nome: 'Magalu',
    desc: 'Parcelamento facilitado e retirada em loja disponível',
    url: 'https://www.magazinevoce.com.br/magazinein_3169663/',
    emoji: '🏪',
    label: 'Magazine Luiza',
    accent: '#0086FF',
    accentText: '#fff',
  },
  {
    nome: 'AliExpress',
    desc: 'Importados direto da fábrica com preços imbatíveis',
    url: 'https://s.click.aliexpress.com/e/_c3UTYHbR',
    emoji: '🌏',
    label: 'AliExpress',
    accent: '#FF4747',
    accentText: '#fff',
  },
];

const GRUPOS = [
  {
    nome: 'Grupo WhatsApp — Ofertas 1',
    desc: 'Achadinhos, cupons e promoções exclusivas direto no seu celular',
    url: 'https://chat.whatsapp.com/HlmS2OcRbQl7AXJrOmkX2e',
    emoji: '💬',
    plat: 'WhatsApp',
    cor: '#25D366',
  },
  {
    nome: 'Grupo WhatsApp — Ofertas 2',
    desc: 'Mais promoções e achadinhos de até 70% OFF todos os dias',
    url: 'https://chat.whatsapp.com/KkfwEJLsKlKGGi3XNPh7qb',
    emoji: '🤑',
    plat: 'WhatsApp',
    cor: '#25D366',
  },
  {
    nome: 'Canal Telegram',
    desc: 'Alertas instantâneos de cupons e ofertas relâmpago',
    url: 'https://t.me/descontosabencoadoss',
    emoji: '✈️',
    plat: 'Telegram',
    cor: '#229ED9',
  },
];

function LojaCard({ item }) {
  return (
    <a href={item.url} target="_blank" rel="noopener noreferrer"
      className="group relative flex flex-col bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl overflow-hidden hover:shadow-xl hover:border-blue-400/40 dark:hover:border-blue-500/40 hover:-translate-y-1 transition-all duration-300">
      {/* Accent strip top */}
      <div className="h-1 w-full" style={{ background: item.accent }}/>
      <div className="p-5 flex flex-col gap-4 flex-1">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700">
              {item.emoji}
            </div>
            <div>
              <h3 className="font-secondary font-bold text-slate-900 dark:text-white text-base leading-tight">{item.nome}</h3>
              <span className="text-xs font-medium px-2 py-0.5 rounded-full mt-1 inline-block"
                style={{ background: item.accent + '22', color: item.accent }}>
                {item.label}
              </span>
            </div>
          </div>
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed flex-1">{item.desc}</p>
        <div className="flex items-center justify-between pt-2 border-t border-slate-100 dark:border-slate-800">
          <span className="text-xs text-slate-400">Clique para acessar</span>
          <div className="flex items-center gap-1 text-sm font-semibold text-blue-600 dark:text-blue-400 group-hover:gap-2 transition-all">
            Visitar <ExternalLink className="w-3.5 h-3.5"/>
          </div>
        </div>
      </div>
    </a>
  );
}

function GrupoCard({ item }) {
  return (
    <a href={item.url} target="_blank" rel="noopener noreferrer"
      className="group flex items-center gap-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-4 hover:shadow-lg hover:border-blue-400/40 dark:hover:border-blue-500/40 hover:-translate-y-0.5 transition-all duration-300">
      {/* Icon circle */}
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0"
        style={{ background: item.cor + '18', border: `1.5px solid ${item.cor}44` }}>
        {item.emoji}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <h3 className="font-secondary font-bold text-slate-900 dark:text-white text-sm">{item.nome}</h3>
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full flex-shrink-0"
            style={{ background: item.cor + '22', color: item.cor }}>
            {item.plat}
          </span>
        </div>
        <p className="text-xs text-slate-500 dark:text-slate-400 line-clamp-2">{item.desc}</p>
      </div>
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-all">
        <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-white transition-colors"/>
      </div>
    </a>
  );
}

export default function AfiliadosPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950">

      {/* Hero — mesmo padrão do site */}
      <section className="relative bg-gradient-to-b from-blue-50 to-white dark:from-slate-900 dark:to-slate-950 py-14 md:py-20 overflow-hidden">
        {/* Decoração de fundo */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/4 w-72 h-72 bg-blue-400/10 dark:bg-blue-500/10 rounded-full blur-3xl"/>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-400/10 dark:bg-cyan-500/8 rounded-full blur-3xl"/>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative text-center space-y-5">
          <div className="inline-flex items-center gap-2 bg-blue-600/10 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400 text-xs font-semibold px-4 py-2 rounded-full border border-blue-200 dark:border-blue-500/30">
            <Zap className="w-3.5 h-3.5"/> Links Oficiais FastFix
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-secondary font-bold tracking-tight text-slate-900 dark:text-white">
            Nossas Lojas &{' '}
            <span className="text-blue-600 dark:text-blue-400">Cupons</span>
          </h1>
          <p className="text-base md:text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto leading-relaxed">
            Encontre nossos produtos nas principais plataformas ou entre grátis nos grupos de cupons para receber promoções exclusivas todos os dias.
          </p>

          {/* Stats rápidos */}
          <div className="flex flex-wrap justify-center gap-6 pt-4">
            {[
              { label: 'Plataformas', valor: '5' },
              { label: 'Grupos ativos', valor: '3' },
              { label: 'Desconto médio', valor: '70%' },
            ].map(s => (
              <div key={s.label} className="text-center">
                <div className="text-2xl font-secondary font-bold text-blue-600 dark:text-blue-400">{s.valor}</div>
                <div className="text-xs text-slate-500 dark:text-slate-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl space-y-16">

          {/* Nossas Lojas */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-9 h-9 bg-blue-600/10 dark:bg-blue-500/20 rounded-xl flex items-center justify-center">
                <ShoppingBag className="w-5 h-5 text-blue-600 dark:text-blue-400"/>
              </div>
              <div>
                <h2 className="font-secondary font-bold text-xl text-slate-900 dark:text-white">Nossas Lojas</h2>
                <p className="text-xs text-slate-500 dark:text-slate-400">Compre com segurança nas maiores plataformas</p>
              </div>
              <div className="flex-1 h-px bg-gradient-to-r from-slate-200 dark:from-slate-800 to-transparent ml-2"/>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {LOJAS.map(l => <LojaCard key={l.nome} item={l}/>)}
            </div>
          </div>

          {/* Grupos de cupons */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-9 h-9 bg-green-600/10 dark:bg-green-500/20 rounded-xl flex items-center justify-center">
                <Tag className="w-5 h-5 text-green-600 dark:text-green-400"/>
              </div>
              <div>
                <h2 className="font-secondary font-bold text-xl text-slate-900 dark:text-white">Grupos de Cupons</h2>
                <p className="text-xs text-slate-500 dark:text-slate-400">Entre grátis e receba ofertas de até 70% OFF</p>
              </div>
              <div className="flex-1 h-px bg-gradient-to-r from-slate-200 dark:from-slate-800 to-transparent ml-2"/>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {GRUPOS.map(g => <GrupoCard key={g.nome} item={g}/>)}
            </div>
          </div>

          {/* CTA WhatsAptp — mesmo estilo do site */}
          <div className="relative overflow-hidden rounded-2xl bg-blue-600 dark:bg-blue-600 p-8 md:p-10 text-white">
            <div className="absolute inset-0 pointer-events-none">
              <div className="absolute -top-10 -right-10 w-48 h-48 bg-white/10 rounded-full blur-2xl"/>
              <div className="absolute -bottom-10 -left-10 w-48 h-48 bg-white/10 rounded-full blur-2xl"/>
            </div>
            <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-2xl">💬</span>
                  <h3 className="font-secondary font-bold text-xl">Fale direto com a FastFix</h3>
                </div>
                <p className="text-blue-100 text-sm max-w-md leading-relaxed">
                  Tire dúvidas, faça pedidos personalizados ou encomendar produtos esgotados. Atendimento rápido pelo WhatsApp!
                </p>
              </div>
              <a href="https://wa.me/5591984036071?text=Olá!%20Vim%20pelo%20site%20da%20FastFix%20e%20gostaria%20de%20mais%20informações."
                target="_blank" rel="noopener noreferrer"
                className="flex-shrink-0 flex items-center gap-2.5 bg-white text-blue-700 font-secondary font-bold px-7 py-3.5 rounded-xl hover:bg-blue-50 transition-colors text-sm shadow-lg whitespace-nowrap">
                <span className="text-lg">📲</span>
                Chamar no WhatsApp
              </a>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
